import _, { cloneDeep, findIndex, isEqual, isEmpty } from 'lodash';
import {
  validateLetters,
  validateNumberAndLetter,
  validatePhoneNumber,
  validateEmail,
} from './CommonUtils';
import {
  CA_ADD_CONTRACT_STATE_OPTIONS,
  CA_ADD_CONTRACT_COUNTRY_OPTIONS,
} from '../constants';

export const createAccFormValidation = (userDetails, tempContract) => {
  let error = '';
  if (userDetails.accountName === '') {
    error = 'Account name required';
  } else if (tempContract.contractName === '') {
    error = 'Contract name required';
  } else if (tempContract.contractNumber === '') {
    error = 'Contract number required';
  } else if (tempContract.contractStart === '') {
    error = 'Contract start date required';
  } else if (tempContract.contractEnd === '') {
    error = 'Contract end date required';
  }
  return error;
};

export const resetContractSectionToDefault = () => {
  const contracts = {
    accessedBasedOn: 'NATIONALSTUDY',
    univIpAddresses: [''],
    universityBackData: '',
    lastNationalStudy: '',
    optInDate: '',
    studyStart: '',
    studyEnd: '',
    optOutDate: '',
    contractNumber: '',
    contractName: '',
    status: 'A',
    statusDate: '',
    contractStart: '',
    contractEnd: '',
    documents: '',
    notes: '',
    documentId: '',
    autoReniewProvision: false,
    marketProvision: false,
    address: {
      zipCode: '',
      phone: '',
      internalContact: '',
      country: '',
      state: '',
      streetAddress: '',
      apt: '',
      city: '',
    },
    // contacts: []
  };
  return contracts;
};

export const cleanupLocationSection = () => {
  const locations = {
    locationName: '',
    companyName: '',
    city: '',
    state: '',
    contactEmail: '',
    contactName: '',
  };
  return locations;
};

export const resetForm = () => {
  const addAccount = {
    accountId: '',
    accountName: '',
    accountType: 'STANDARD',
    industryTypeDesc: '',
    activeStatus: 'Y',
    accountLinkType: 'No Link',
    parentAccountId: null,
    contracts: [
      {
        accessedBasedOn: 'NATIONALSTUDY',
        univIpAddresses: [''],
        universityBackData: '',
        lastNationalStudy: '',
        optInDate: '',
        optOutDate: '',
        studyStart: '',
        studyEnd: '',
        contractNumber: '',
        contractName: '',
        status: 'A',
        statusDate: '',
        contractStart: '',
        contractEnd: '',
        documents: '',
        documentId: '',
        notes: '',
        address: {
          zipCode: '',
          phone: '',
          internalContact: '',
          country: '',
          state: '',
          streetAddress: '',
          apt: '',
          city: '',
        },
        // contacts: []
      },
    ],
    locations: [],
    id: '',
  };
  return addAccount;
};

export const checkduplicate = (data, obj) => {
  let check = false;
  const index = findIndex(data, obj);
  if (index > -1) {
    check = true;
  }
  return check;
};

export const emailValidation = value => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const onSubmitFormValidation = (
  userDetails,
  tempContract,
  tempLocation
) => {
  let error = '';
  if (userDetails.accountName === '') {
    error = 'Account name required';
  } else if (userDetails.industryTypeDesc === '') {
    error = 'Vertical is required';
  } else if (tempContract.contractName === '') {
    error = 'Contract name required';
  } else if (tempContract.contractNumber === '') {
    error = 'Contract number required';
  } else if (tempContract.contractNumber.length > 20) {
    error = 'Contract Number cannot be greater than 20.';
  } else if (tempContract.contractStart === '') {
    error = 'Contract start date required';
  } else if (tempContract.contractName.length > 250) {
    error = 'Contract Name cannot be greater than 250.';
  } else if (tempLocation.contactName && tempLocation.contactName.length > 0) {
    const value = validateLetters(tempLocation.contactName);
    if (!value) {
      error = 'Contact Name should only allow alphabet';
    }
    if (tempLocation.contactEmail && tempLocation.contactEmail.length > 1) {
      const value = validateEmail(tempLocation.contactEmail);
      console.log('Email validated');
      if (!value) {
        error = 'Email should only allow alpha numeric and symbols';
      }
    }
    if (
      tempContract.contractNumber &&
      tempContract.contractNumber.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateNumberAndLetter(tempContract.contractNumber);
      if (!value) {
        error = 'Contract Number should only allow alpha numeric';
      }
    }
    if (
      tempContract.address.phone &&
      tempContract.address.phone.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validatePhoneNumber(tempContract.address.phone);
      if (!value) {
        error = 'Phone number should only allow numbers';
      }
    }
    if (
      tempContract.address.internalContact &&
      tempContract.address.internalContact.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateLetters(tempContract.address.internalContact);
      if (!value) {
        error = 'Internal contact should only allow alphabet';
      }
    }
  } else if (tempContract.contractEnd === '') {
    error = 'Contract end date required';
  } else if (
    userDetails.industryTypeDesc === 'University' &&
    !tempContract.universityBackData
  ) {
    error = 'A University only selection must be made.';
  } else if (!isEmpty(userDetails.univIpAddresses)) {
    for (let i = 0; i < userDetails.univIpAddresses.length; i += 1) {
      const patt = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      const ipv41 = userDetails.univIpAddresses[i].split('-')[0];
      const ipv42 = userDetails.univIpAddresses[i].split('-')[1];
      const test1 = ipv41 && !patt.test(ipv41.trim());
      const test2 = ipv42 && !patt.test(ipv42.trim());
      if ((ipv42 && !ipv41) || (ipv41 && !ipv42)) {
        error = 'Please enter both IP addresses in the range.';
      }
      if (test1 || test2) {
        error = 'You have entered an invalid IP address!';
      }
    }
  } else {
    if (
      tempContract.contractNumber &&
      tempContract.contractNumber.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateNumberAndLetter(tempContract.contractNumber);
      if (!value) {
        error = 'Contract Number should only allow alpha numeric';
      }
    }
    if (
      (tempContract.status === 'D' || tempContract.status === 'H') &&
      !tempContract.statusDate
    ) {
      error = 'Please select the Disabled or Hold status date for contract';
    }
    if (
      tempContract.address.zipcode &&
      tempContract.address.zipcode.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateNumberAndLetter(tempContract.address.zipcode);
      if (!value) {
        error = 'zipcode should only alpha numeric';
      }
    }
    if (
      tempContract.address.phone &&
      tempContract.address.phone.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validatePhoneNumber(tempContract.address.phone);
      if (!value) {
        error = 'Phone number should only allow numbers';
      }
    }
    if (
      tempContract.address.internalContact &&
      tempContract.address.internalContact.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateLetters(tempContract.address.internalContact);
      if (!value) {
        error = 'Internal contact should only allow alphabet';
      }
    }
    if (
      tempLocation.contactName &&
      tempLocation.contactName.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = validateLetters(tempLocation.contactName);
      if (!value) {
        error = 'Contact Name should only allow alphabet';
      }
    }
    if (
      tempLocation.contactEmail &&
      tempLocation.contactEmail.length > 0 &&
      _.isEmpty(error)
    ) {
      const value = emailValidation(tempLocation.contactEmail);
      if (!value) {
        error = 'Email should only allow alpha numeric and symbols';
      }
    }
    if (
      tempLocation.contactEmail ||
      tempLocation.contactName ||
      tempLocation.companyName ||
      tempLocation.city ||
      tempLocation.state
    ) {
      if (!tempLocation.locationName) {
        error = 'Location name required';
      }
    }
  }
  if (tempLocation.locationName === '') {
    error = 'Location name required';
  } else if (tempLocation.companyName === '') {
    error = 'Company name required';
  } else if (tempLocation.city === '') {
    error = 'Location City is required';
  }
  if (tempContract.address.country === 'USA') {
    if (!tempContract.address.state) error = 'State is required';
    else if (!tempContract.address.city) error = 'City name required';
    else if (!tempContract.address.zipCode) error = 'Zipcode is required';
  } else if (tempContract.address.country === 'OTHER') {
    if (!tempContract.address.city) error = 'City name required';
  }

  return error;
};

export const getSelectedLocationState = state => {
  const index = findIndex(CA_ADD_CONTRACT_STATE_OPTIONS, {
    value: state,
  });
  const selectedObj = index === -1 ? '' : CA_ADD_CONTRACT_STATE_OPTIONS[index];
  return selectedObj;
};

export const getSelectedLocationCountry = selectedVal => {
  const index = findIndex(CA_ADD_CONTRACT_COUNTRY_OPTIONS, {
    value: selectedVal,
  });
  const selectedObj =
    index === -1 ? '' : CA_ADD_CONTRACT_COUNTRY_OPTIONS[index];
  return selectedObj;
};

export const buildArrayForLoc = data => {
  let isdataAvailabe = false;
  const isData = _.every(data, {
    locationName: '',
  });
  if (isData && data.length > 0) {
    isdataAvailabe = true;
  }
  return isdataAvailabe;
};

export const getSelectedStatus = (value, options) => {
  const obj = _.find(options, {
    value,
  });
  return obj.label;
};

export const checkUnSavedChanges = (
  e,
  field,
  section,
  subSection,
  tempContracts,
  tempLocations,
  addAccount,
  selectedConIndex,
  selectedLocIndex
) => {
  const changedObj = cloneDeep(addAccount);

  const conIndex = selectedConIndex === '' ? 0 : selectedConIndex;
  const locIndex = selectedLocIndex === '' ? 0 : selectedLocIndex;
  // const changeVal = false;
  const fieldVal = e.target !== undefined ? e.target.value : e;
  if (section === undefined) {
    changedObj[field] = fieldVal;
  } else if (section === 'contracts' && subSection === undefined) {
    changedObj.contracts[conIndex][field] = fieldVal;
  } else if (section === 'contracts' && subSection !== undefined) {
    changedObj.contracts[conIndex][subSection][field] = fieldVal;
  } else if (section === 'locations' && changedObj.locations.length !== 0) {
    changedObj.locations[locIndex][field] = fieldVal;
  } else if (section === 'locations' && changedObj.locations.length === 0) {
    changedObj.locations.push(cleanupLocationSection());
    changedObj.locations[0][field] = fieldVal;
  }
  return changedObj;
};

export const isSectionBlank = (contract, locations) => {
  const isContractBlank = isEqual(contract, resetContractSectionToDefault());
  const isLocationBlank = isEqual(locations, cleanupLocationSection());
  return [isContractBlank, isLocationBlank];
};

export const hasError = (errorMsg, onSaveErrMsg) => {
  let onSaveError = false;
  if (!_.isEmpty(errorMsg) || !_.isEmpty(onSaveErrMsg)) {
    onSaveError = true;
  }
  return onSaveError;
};

export const isDisable = (
  parent,
  child,
  addAccount,
  addNewFlag,
  addNewEntitlement
) => {
  let isDisable = false;
  const isIdPresent = addAccount.accountId !== '';
  if (child === 'Details' && !isIdPresent && addNewFlag !== true) {
    isDisable = true;
  } else if (
    child === 'Entitlement Creation' &&
    !isIdPresent &&
    addNewEntitlement !== true
  ) {
    isDisable = true;
  } else if (
    child === 'Summary' &&
    !isIdPresent &&
    addNewEntitlement !== true
  ) {
    isDisable = true;
  }
  return isDisable;
};

export const mapStudyData = data => {
  const comparisonData = data.map(
    ({
      nodes,
      selected,
      isAnyChildSelected,
      autoAdd,
      autoRemove,
      historicalData,
    }) => ({
      nodes: nodes ? mapStudyData(nodes) : null,
      selected: selected ? selected : false,
      isAnyChildSelected: isAnyChildSelected ? isAnyChildSelected : false,
      autoAdd: autoAdd ? autoAdd : false,
      autoRemove: autoRemove ? autoRemove : false,
      historicalData: historicalData ? historicalData : null,
    })
  );
  return comparisonData;
};

const comparisonData = data => {
  const retData = data.map(
    ({ selected, maxSeats, modules, optionId, optionName, seatsRequired }) => ({
      selected: selected ? selected : false,
      maxSeats: maxSeats ? maxSeats : null,
      modules: modules ? comparisonData(modules) : [],
      optionId,
      optionName,
      seatsRequired,
    })
  );
  return retData;
};
export const mapProdData = (data, isTPPAccountSelected) => {
  const filteredData = data.filter(item => {
    if (isTPPAccountSelected) {
      return (
        item.optionName !== 'Resources' ||
        item.optionName !== 'Third Party Provider' ||
        !item.disable
      );
    } else {
      return item.optionName !== 'Resources';
    }
  });
  const retData = comparisonData(filteredData);
  return retData;
};

export const isEntDataChanged = data => {
  let isEntdataChanged = false;

  if (data) {
    isEntdataChanged = true;
  }
  return isEntdataChanged;
};

export const getContractList = contractList => {
  const contractDropDownList = _.map(contractList, item => {
    return {
      label: item.contractName,
      contractId: item.contractId,
    };
  });
  return contractDropDownList;
};

export const getPropCodeType = list => {
  const listOdDropDown = _.map(list, item => {
    return {
      label: item,
    };
  });
  return listOdDropDown;
};
export const mapPropCode = list => {
  const listData = _.map(list, item => {
    return {
      id: item.id,
    };
  });
  return listData;
};
export const getLocationsList = locationsList => {
  const contractDropDownList = _.map(locationsList, item => {
    return {
      label: item.locationName,
      locationId: item.locationId,
    };
  });
  return contractDropDownList;
};

export const mapProperties = data => {
  const returnProdData = data.map(
    ({
      all,
      displayOrder,
      maxSeats,
      modules,
      optionId,
      optionName,
      seatsRequired,
      selected,
    }) => ({
      all,
      displayOrder,
      maxSeats,
      modules,
      optionId,
      optionName,
      seatsRequired,
      selected,
    })
  );
  return returnProdData;
};
export const mapLocProperties = data => {
  const returnLocData =
    data && data.length
      ? data.map(({ locationId }) => ({
          locationId,
        }))
      : '';
  return returnLocData;
};

export const getBlockHeight = data => {
  const height = data.length * 100 + 15;
  const obj = {
    height: `${height}px`,
    color: 'black',
    borderLeft: '1px solid black !important',
  };
  return obj;
};

export const getYears = item => {
  const years = item.years.join(',  ');
  return years.toString();
};

export const getDefaultSummaryLocAndCon = (
  section,
  selectedContract,
  selectedLocation
) => {
  let obj = {};
  if (section === 'contract') {
    if (!_.isEmpty(selectedContract)) {
      obj = {
        label: selectedContract.contractName,
        contractId: selectedContract.contractId,
      };
    }
  } else if (!_.isEmpty(selectedLocation)) {
    obj = {
      label: selectedLocation.locationName,
      locationId: selectedLocation.locationName.locationId,
    };
  }
  return obj;
};
export const isAccountDetailChangedFun = (ref, oldData) => {
  let isdataChanged = false;
  const data = ref.current;
  const newDataObj = data.userDetails;
  const conIndex = data.selectedContractIndex;
  const locIndex = data.selectedLocationIndex;
  const tempContract = data.tempContract;
  const tempLocation = data.tempLocation;
  const locationsList = data.locationsList;
  const contractsList = data.contractsList;
  const newData = cloneDeep(newDataObj);
  if (conIndex !== '') {
    const updateContractList = cloneDeep(contractsList);
    updateContractList[conIndex] = tempContract;
    newData.contracts = updateContractList;
    if (!isEqual(oldData.contracts, updateContractList)) {
      isdataChanged = true;
    }
  } else if (contractsList.length === 0) {
    isdataChanged = !isEqual(oldData.contracts[0], tempContract) === true;
  } else {
    isdataChanged = !!(
      !isEqual(tempContract, resetContractSectionToDefault()) ||
      !isEqual(oldData.contracts, contractsList) === true
    );
  }
  if (locIndex !== '') {
    const updatelocList = cloneDeep(locationsList);
    updatelocList[locIndex] = tempLocation;
    newData.locations = updatelocList;
    if (!isEqual(oldData.locations, updatelocList)) {
      isdataChanged = true;
    }
  } else if (locIndex === '') {
    if (
      locationsList.length === 0 &&
      !isEqual(oldData.locations, locationsList)
    ) {
      isdataChanged = true;
    } else if (
      !isEqual(tempLocation, cleanupLocationSection()) ||
      !isEqual(oldData.locations, locationsList)
    ) {
      isdataChanged = true;
    }
  }
  if (
    newData.accountName !== oldData.accountName ||
    newData.accountType !== oldData.accountType ||
    newData.industryTypeDesc !== oldData.industryTypeDesc
  ) {
    isdataChanged = true;
  }
  return isdataChanged;
};
